import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from '../../utils/classnames';

export default class ScheduleRow extends Component {
  onClick(time) {
    const { schedule, day, onSelect } = this.props;
    onSelect(day, time, !_.get(schedule, time));
  }

  onMorningClick = this.onClick.bind(this, 'morning')
  onNoonClick = this.onClick.bind(this, 'noon')
  onAfternoonClick = this.onClick.bind(this, 'afternoon')

  render() {
    const { day, schedule } = this.props;
    return (
      <div className="col-md-2">
        <div className="form-group">
          <label className="control-label">{I18n.t(`extras.days.${day}`)}</label>
          <span>{I18n.t(`extras.days.${day}`).substr(0, 3)}</span>
          <div className="btn-group" role="group" aria-label="">
            <button type="button" className={classnames('btn', { active: _.get(schedule, 'morning') })} onClick={this.onMorningClick}>{I18n.t('students.form.address_morning')}</button>
            <button type="button" className={classnames('btn', { active: _.get(schedule, 'noon') })} onClick={this.onNoonClick}>{I18n.t('students.form.address_noon')}</button>
            <button type="button" className={classnames('btn', { active: _.get(schedule, 'afternoon') })} onClick={this.onAfternoonClick}>{I18n.t('students.form.address_afternoon')}</button>
          </div>
        </div>
      </div>
    );
  }
}

export const scheduleDayShape = PropTypes.shape({
  morning: PropTypes.bool,
  noon: PropTypes.bool,
  afternoon: PropTypes.bool,
});

ScheduleRow.propTypes = {
  day: PropTypes.string.isRequired,
  schedule: scheduleDayShape,
  onSelect: PropTypes.func.isRequired,
};
